import React, {useContext} from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
//import { /*RoutePrivate,*/ RouteRestricted } from './utils/routes';
import {UserContext, UserProvider} from './utils/usercontext';
import Socket from './utils/socket';
//import Donation from './routes/components/donation/donation';
//import Notifications from './routes/components/notifications/notifications';
//import Fault from './routes/components/fault/fault';

//---- Main components
import Header from './routes/header';
import Footer from './routes/footer';
import Loading from './routes/loading';

//---- User account pages
import AccountLogin from './routes/account/login';
import AccountLogout from './routes/account/logout';
import AccountRecover from './routes/account/recover';
import AccountRegister from './routes/account/register';
import AccountValidate from './routes/account/validate';
import AccountInvite from './routes/account/invite';
import AccountInvoices from './routes/account/invoices';
import AccountInvoice from './routes/account/invoice';


//---- Pages
import PortalIndex from './routes/index';
import PortalStreamKey from './routes/streamkey';
//import News from './routes/news';
//import StreamKey from './routes/streamkey';
//import Docs from './routes/docs';





//---- Profile pages
import PortalProfile from './routes/profile/profile';
import PortalSettings from './routes/profile/settings';

//----- Services
import PortalServiceOverview from './routes/service/overview';
import PortalServiceLiveStream from './routes/service/livestream';
import PortalServiceSchedule from './routes/service/schedule';
import PortalServiceTemplate from './routes/service/template';
import PortalServiceAnalytics from './routes/service/analytics';
import PortalServiceFileManager from './routes/service/filemanager';
import PortalServiceReplays from './routes/service/replays';
import PortalServiceReplay from './routes/service/replay';

//---- Services Admin
import PortalAdminOverview from './routes/admin/overview';
import PortalAdminInvites from './routes/admin/invites';
import PortalAdminAccounts from './routes/admin/accounts';
import PortalAdminPlatforms from './routes/admin/platforms';
import PortalAdminDiscord from './routes/admin/discord';
import PortalAdminEmbeds from './routes/admin/embeds';
import PortalAdminAuthentication from './routes/admin/authentication';
//import PortalAdminOrganiser from './routes/admin/organiser';
//import PortalAdminRecordings from './routes/admin/recordings';

//---- Embeds
//import EmbedVideo from './routes/embed/video';


//---- CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './routes/css/velvet.css';
import './routes/css/app.css';
import './routes/css/boxicons.css';

const ViewLogin = (props) => {
  const value = useContext(UserContext);
  let location = window.location.pathname.indexOf('/p/') === 0 ? true : false;
  if( !value.user.user ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Loading />} />
        </Routes>
      </BrowserRouter>
    )
  } else if( value.user?.user?.id > 1 && value.user?.user?.verified === true ) {
      return (
        <>
          {location === true ?
            <BrowserRouter>
              <Routes>
                <Route path={"/p/:username"} exact element={<PortalProfile portable={true} />} />
              </Routes>
            </BrowserRouter>
          :
            <>
              {props.children}
            </>
          }
          
        </>
      )
  } else if( value.user?.user?.id > 1 && value.user?.user?.verified === false ) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path={"/recover"} exact element={<AccountRecover />} />
          <Route path={"/recover/:key"} exact element={<AccountRecover />} />
          <Route path={"/register/:code"} exact element={<AccountRegister />} />
          <Route path="/logout" element={<AccountLogout />} />
          <Route path="*" element={<AccountValidate />} />
        </Routes>
      </BrowserRouter>
    )
  } else {
    return (
      <BrowserRouter>
        <Routes>
          {/*<Route path={"/video/:service"} exact element={<EmbedVideo />} />*/}
          <Route path={"/p/:username"} exact element={<PortalProfile />} />
          <Route path="/logout" element={<AccountLogout />} />
          <Route path={"/recover"} exact element={<AccountRecover />} />
          <Route path={"/recover/:key"} exact element={<AccountRecover />} />
          <Route path={"/register"} exact element={<AccountRegister />} />
          <Route path={"/register/:code"} exact element={<AccountRegister />} />
          <Route path="*" element={<AccountLogin />} />
        </Routes>
      </BrowserRouter>
    )
  }
}


function App() {
  return (
    <div className="page">
      <UserProvider>
        <ViewLogin>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route path="/" exact element={<PortalIndex />} />
              <Route path="/logout" element={<AccountLogout />} />

              <Route path={"/streamkey"} exact element={<PortalStreamKey />} />
              
              
              <Route path={"/register/:code"} exact element={<AccountRegister />} />
              <Route path={"/join/:code"} exact element={<AccountInvite />} />

              <Route path={"/invoices"} exact element={<AccountInvoices />} />
              <Route path={"/invoice/:invoice"} exact element={<AccountInvoice />} />
              
              

              <Route path={"/profile/:username"} exact element={<PortalProfile />} />
              <Route path={"/settings"} exact element={<PortalSettings />} />
              <Route path={"/settings/:username"} exact element={<PortalSettings />} />

              <Route path={"/authentication/:platform"} exact element={<PortalAdminAuthentication />} />
              
              <Route path={"/:service"} exact element={<PortalServiceOverview />} />
              <Route path={"/:service/live"} exact element={<PortalServiceLiveStream />} />
              <Route path={"/:service/schedule"} exact element={<PortalServiceSchedule />} />
              <Route path={"/:service/template"} exact element={<PortalServiceTemplate />} />
              <Route path={"/:service/analytics"} exact element={<PortalServiceAnalytics />} />
              <Route path={"/:service/filemanager"} exact element={<PortalServiceFileManager />} />
              <Route path={"/:service/replays"} exact element={<PortalServiceReplays />} />
              <Route path={"/:service/replay/:id"} exact element={<PortalServiceReplay />} />

              <Route path={"/:service/admin"} exact element={<PortalAdminOverview />} />
              <Route path={"/:service/invites"} exact element={<PortalAdminInvites />} />
              <Route path={"/:service/accounts"} exact element={<PortalAdminAccounts />} />
              <Route path={"/:service/platforms"} exact element={<PortalAdminPlatforms />} />
              <Route path={"/:service/discord"} exact element={<PortalAdminDiscord />} />
              <Route path={"/:service/embeds"} exact element={<PortalAdminEmbeds />} />
              
              {/*<Route path={"/:service/organiser"} exact element={<PortalAdminOrganiser />} />
              <Route path={"/:service/recordings"} exact element={<PortalAdminRecordings />} />*/}
    
              
              
            </Routes>
            <Footer />
            <Socket />
          </BrowserRouter>
        </ViewLogin>
      </UserProvider>
    </div>
  );
}

export default App;
